import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import { BOARD_STATS_BAR_HEIGHT } from "~/_components/BoardStatsBar";
import { KANBAN_VIEW_CONTAINER } from "~/constants/testIDs";
import { AirDndContext } from "./AirDndContext";
import { KanbanColumnsManagers } from "./KanbanColumnsManagers/KanbanColumnsManagers";
import { KanbanLoadingState } from "./KanbanLoadingState";
import { useGetSingleSelectCustomFields } from "./useGetSingleSelectCustomFields";
export const KanbanView = /*#__PURE__*/ memo((param)=>{
    let { NullState, tableHeaderTopPos, customFields, baseCustomField, customFieldValues, canViewCustomFields, style: styleProp } = param;
    const { hasSingleSelectCustomFields } = useGetSingleSelectCustomFields(customFields);
    const loadingState = useMemo(()=>/*#__PURE__*/ _jsx(KanbanLoadingState, {}), []);
    const style = useMemo(()=>({
            height: "calc(100vh - ".concat((tableHeaderTopPos !== null && tableHeaderTopPos !== void 0 ? tableHeaderTopPos : 0) + BOARD_STATS_BAR_HEIGHT, "px)"),
            ...styleProp
        }), [
        styleProp,
        tableHeaderTopPos
    ]);
    if (!canViewCustomFields) return /*#__PURE__*/ _jsx(NullState, {});
    return /*#__PURE__*/ _jsx(AirDndContext, {
        children: /*#__PURE__*/ _jsx("div", {
            className: "size-full bg-grey-2 py-4",
            "data-testid": KANBAN_VIEW_CONTAINER,
            style: style,
            children: customFields ? hasSingleSelectCustomFields ? /*#__PURE__*/ _jsx(KanbanColumnsManagers, {
                loadingState: loadingState,
                baseCustomField: baseCustomField,
                customFieldValues: customFieldValues
            }) : /*#__PURE__*/ _jsx(NullState, {}) : loadingState
        })
    });
});
KanbanView.displayName = "KanbanView";
